/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-api.envdevel.com/_doc/doc.json
*/

import type {
  InputAccessRequest,
  InputContact,
  InputFuzzyLocationOverwritePatch,
  OutputEmpty,
  OutputLeadResponse,
  OutputPatchFuzzyLocationOverwriteResponse
} from '../models';

import { customInstance } from '../custom-instance';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Access request lead for restricted listings, usually private office.
 * @summary Lead access request for restricted listings.
 */
export const listingRequestAccess = (
    listingID: string,
    inputAccessRequest: InputAccessRequest,
 options?: SecondParameter<typeof customInstance<OutputEmpty>>,) => {
      return customInstance<OutputEmpty>(
      {url: `/api/listing/${listingID}/access`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inputAccessRequest
    },
      options);
    }

/**
 * Lead contact form to request further information, viewing, callback, etc. for a certain listing
 * @summary Lead Contact request form.
 */
export const listingLead = (
    listingID: string,
    inputContact: InputContact,
 options?: SecondParameter<typeof customInstance<OutputLeadResponse>>,) => {
      return customInstance<OutputLeadResponse>(
      {url: `/api/listing/${listingID}/lead`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inputContact
    },
      options);
    }

/**
 * Delete a fuzzy location overwrite. It will trigger a replay for the listing if it exists.
 * @summary Delete fuzzy location overwrite.
 */
export const overwriteFuzzylocationDelete = (

 options?: SecondParameter<typeof customInstance<OutputPatchFuzzyLocationOverwriteResponse>>,) => {
      return customInstance<OutputPatchFuzzyLocationOverwriteResponse>(
      {url: `/api/overwrite/fuzzy_location`, method: 'DELETE'
    },
      options);
    }

/**
 * Patch a fuzzy location overwrite. If the listingID exists it will trigger a replay.
 * @summary Patch fuzzy location overwrite.
 */
export const overwriteFuzzylocationPatch = (
    inputFuzzyLocationOverwritePatch: InputFuzzyLocationOverwritePatch,
 options?: SecondParameter<typeof customInstance<OutputPatchFuzzyLocationOverwriteResponse>>,) => {
      return customInstance<OutputPatchFuzzyLocationOverwriteResponse>(
      {url: `/api/overwrite/fuzzy_location`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: inputFuzzyLocationOverwritePatch
    },
      options);
    }

export type ListingRequestAccessResult = NonNullable<Awaited<ReturnType<typeof listingRequestAccess>>>
export type ListingLeadResult = NonNullable<Awaited<ReturnType<typeof listingLead>>>
export type OverwriteFuzzylocationDeleteResult = NonNullable<Awaited<ReturnType<typeof overwriteFuzzylocationDelete>>>
export type OverwriteFuzzylocationPatchResult = NonNullable<Awaited<ReturnType<typeof overwriteFuzzylocationPatch>>>
